import React, { useState } from "react";
import { Loader2Icon, DownloadIcon, ExternalLinkIcon } from "lucide-react";
import server from "../utils/serverConfig";

const FileUpload = () => {
  const [file, setFile] = useState(null);
  const [htmlContent, setHtmlContent] = useState(null);
  const [fileName, setFileName] = useState('');
  const [fileProcessing, setFileProcessing] = useState(false);
  const [reportGenerated, setReportGenerated] = useState(false);

  const serverUrl =`${server.godseye.baseUrl}upload` ;
  const devUrl = `${server.godseye.baseUrl}upload` ;

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setFileName(e.target.files[0].name);
  };

  const handleUpload = async () => {
    setFileProcessing(true);
    if (file) {
      const formData = new FormData();
      formData.append("file", file);

      try {
        const response = await fetch(serverUrl, {
          method: "POST",
          body: formData,
        });

        const html = await response.text();
        setHtmlContent(html);
        setFileProcessing(false);
        setReportGenerated(true);
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    } else {
      console.warn("No file selected!");
    }
  };

  const handleViewHtml = () => {
    if (htmlContent) {
      // Open the HTML content in a new tab
      const newWindow = window.open();
      newWindow.document.open();
      newWindow.document.write(htmlContent);
      newWindow.document.close();
    } else {
      console.warn('No HTML content to view!');
    }
  };

  const handleDownloadHTML = () => {
    if (htmlContent) {
      // Trigger file download
      const blob = new Blob([htmlContent], { type: 'text/html' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${fileName.split('.')[0]}_full_report.html`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } else {
      console.warn('No HTML content to download!');
    }
  };


  return (
    <div className="flex flex-col space-y-6">
      <div className="flex flex-col w-[400px] space-y-6 items-center p-4 ">
        <input
          type="file"
          onChange={handleFileChange}
          className="text-white font-medium w-full  file:mr-6 file:py-2 file:px-4 file:bg-[#07F2C7]/20 file:font-semibold file:border-none file:rounded-md file:text-white hover:file:bg-[#07F2C7]/30"
        />

        <button
          onClick={handleUpload}
          className="bg-[#07F2C7] w-full hover:bg-[#07F2C7]/80 text-lg text-black font-bold py-2 px-4 rounded"
        >
          {fileProcessing ? (
            <div className="flex space-x-2 items-center justify-center">
              <Loader2Icon className="h-5 w-5 animate-spin" />
              <span>Generating Report...</span>
            </div>
          ) : (
            "Upload File"
          )}
        </button>
      </div>

      {reportGenerated && (
        <div className="text-2xl font-medium text-center text-white px-4">
          Report Generated Successfully !!
        </div>
      )}

      {htmlContent && (
        <div className="flex  pt-10 w-full px-4">
          <button
            onClick={handleViewHtml}
            className="flex items-center justify-center space-x-2 w-full bg-gray-700/70 text-white font-semibold py-2 px-4 rounded mr-2"
          >
            <ExternalLinkIcon className="h-4 w-4" />
            <span> View HTML</span>
          </button>
          <button
            onClick={handleDownloadHTML}
            className="flex items-center justify-center space-x-2 w-full bg-[#07F2C7] hover:bg-[#07F2C7]/80 text-black font-bold py-2 px-4 rounded"
          >
            <DownloadIcon className="h-4 w-4" />
            <span> Download HTML</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default FileUpload;
